import { useState } from 'react';

import { useToastStore } from '../../../stores/toast-store';

import { buildResetLink } from './invite-link';

import type { PasswordResetLinkWire } from './types';

/** O link de redefinição gerado pelo gestor (Item 477). O segredo só aparece aqui, uma vez. */
export function PasswordResetLinkPanel({
  link,
  onClose,
}: {
  link: PasswordResetLinkWire;
  onClose: () => void;
}): JSX.Element {
  const url = buildResetLink(window.location.origin, link.resetSecret);
  const push = useToastStore((s) => s.push);
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      push({ variant: 'success', title: 'Link copiado', durationMs: 2500 });
    } catch {
      push({
        variant: 'error',
        title: 'Não deu para copiar automaticamente',
        description: 'Selecione o link e copie à mão.',
      });
    }
  }

  const until = new Date(link.expiresAt).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div
      className="rounded-lg border border-border-subtle bg-surface-raised p-3 space-y-2"
      role="status"
      aria-label="Link de redefinição de senha"
      data-testid="reset-link-panel"
    >
      <p className="text-xs text-text-secondary">
        Entregue este link a <span className="font-mono">{link.email}</span>. Vale até {until} e só
        aparece agora.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <input
          className="input flex-1 min-w-48 font-mono text-xs"
          readOnly
          value={url}
          aria-label="Link de redefinição de senha"
          onFocus={(e) => e.currentTarget.select()}
        />
        <button type="button" className="btn btn--primary btn--sm" onClick={() => void copy()}>
          {copied ? 'Copiado' : 'Copiar link'}
        </button>
        <button type="button" className="btn btn--ghost btn--sm" onClick={onClose}>
          Fechar
        </button>
      </div>
    </div>
  );
}
